import Axios from 'axios';

import {
	ALL_APPS_LOADING,
	ALL_APPS_GET,
	ALL_APPS_GET_ERROR,
	APP_CONFIG_GET,
	APP_CONFIG_ERROR
} from './types';

export const get_all_apps = () => dispatch => {
	dispatch({
		type: ALL_APPS_LOADING,
		payload: true
	})
	
	let url = process.env.REACT_APP_SERVER_URL + '/api/apps?type=2';

	Axios.get(url)
	.then((res) => {
		dispatch({
			type: ALL_APPS_GET,
			payload: res.data
		})
	}).catch((err) => {
		dispatch({
			type: ALL_APPS_GET_ERROR,
			payload: {type: 'all_apps', msg: err.message}
		})
	})
}

export const get_app_config = () => dispatch => {
	const url = `${process.env.REACT_APP_SERVER_URL}/api/apps/screens/data?app=${process.env.REACT_APP_ALIAS}`;

	Axios.get(url)
	.then((res) => {
		dispatch({
			type: APP_CONFIG_GET,
			payload: res.data
		})
	}).catch((err) => {
		dispatch({
			type: APP_CONFIG_ERROR,
			payload: { type: 'app_config', msg: err.message }
		})
	})
}
